import React from "react";
import styled, { css } from "styled-components";

import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal";
import { Text } from "src/library/components/Text";
import { PointOfContact } from "src/core/drops/api/drops.api";

type LoginHelpModalProps = {contactDetails: PointOfContact} & Pick<BasicModalProps, "onDismiss" | "open">;

export const LoginHelpModal: React.ReactFCWithChildren<LoginHelpModalProps> = ({
  onDismiss, open, contactDetails
}) => {
  return (
    <BasicModal
      title="Need help?"
      open={open}
      onDismiss={onDismiss}
    >
      <Text>
        Having trouble logging into your account? Try resetting your password by clicking "Forgot Password" or get in touch.
        <br />

        <br />

        {contactDetails.contactName}

        <br />

        {contactDetails.contactEmail}

        <br />

        {contactDetails.contactNumber}

        <br />
      </Text>

      <FooterWrapper>
        <DismissButtonWrapper onClick={onDismiss}>

          <Text
            className="dismiss-button"
          >
            OK
          </Text>
        </DismissButtonWrapper>
      </FooterWrapper>
    </BasicModal>
  );
};

const FooterWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: ${theme.spacing.margins.md};
    margin-right: ${theme.spacing.margins.sm};
  `}
`;

const DismissButtonWrapper = styled.div`
  ${({ theme }) => css`
    cursor: pointer;

    .dismiss-button {
      color: ${theme.colors.primaryDark};
    }
  `}
`;